module.exports = __webpack_public_path__ + "img/532-9ec300.png";